import check from './assets/ic_proyecto_check_verde.svg';
import greenBorder from './assets/ic_proyecto_circulo_borde_verde.svg';
import point from './assets/ic_general_punto_gris.svg';
import styles from './styles.module.scss';

export const ICON_IN_PRODUCTION = { svg: greenBorder, className: styles.inProduction };
export const ICON_NOT_STARTED = { svg: point, className: styles.notStarted };
export const ICON_FINISHED = { svg: check, className: styles.finished };
export const LINE_LENGTH: string = '100%';
